import React from "react";
import { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import axios from "axios";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

// material-ui icons
import { Add, Computer, ErrorOutline, Layers, Pageview, Restaurant, SmartDisplay, WbCloudy } from "@mui/icons-material";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";
import Button from "../../components/CustomButtons/Button";

import vestigingStyle from "../../assets/jss/material-dashboard-pro-react/views/vestigingStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import * as actions from "../../store/actions";

//Modals
import Copy from "./Modals/Copy";
import New from "./Modals/New";
import { DialogContext } from "../../licensing/utils/DialogProvider";
import VenueFilter from "../../components/Filters/VenueFilter";
import { JamezzTableLinkToRelation } from "../../components/JamezzTable/JamezzTableFields";
import TextFilter from "../../components/Filters/TextFilter";
import PayProviderFilter from "../../components/Filters/PayProviderFilter";
import ApiProviderFilter from "../../components/Filters/ApiProviderFilter";
import AuthenticationWrapper from "../../auth/AuthenticationWrapper";
import AppTargetFilter from "../../components/Filters/AppTargetFilter";
import TargetPlatformFilter from "../../components/Filters/TargetPlatformFilter";
import SalesareaTypeFilter from "../../components/Filters/SalesareaTypeFilter";
import CountryFilter from "../../components/Filters/CountryFilter";
import { toast } from "react-toastify";
import { differenceInDays, differenceInHours, differenceInMinutes, differenceInSeconds, parse } from "date-fns";
import { DatePicker } from "@mui/x-date-pickers";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIds: [],
      copyModal: false,
      newModal: false,
    };
  }

  jamezzTable = React.createRef();

  /**
   * Handle refresh table
   */
  refreshJamezzTable = () => {
    this.jamezzTable.current.refreshData();
  };

  /**
   * Modal functies
   */
  toggleModal(modal) {
    const newState = { ...this.state };
    newState[modal] = !this.state[modal];
    this.setState(newState);
  }

  migrateToStable() {
    axios
      .get("/core/vestigingen/tostable")
      .then((response) => {
        if (response.data.data.success) {
          toast.success(response.data.data.message);
        } else {
          toast.error(response.data.data.message);
        }
      })
      .catch((error) => {
        /**
         * Alleen niet CANCEL errors afvangen
         */
        if (!error.__CANCEL__) {
          toast.error("Oeps er is iets mis gegaan!");
        }
      });
  }

  migrateToRC() {
    axios
      .get("/core/vestigingen/torc")
      .then((response) => {
        if (response.data.data.success) {
          toast.success(response.data.data.message);
        } else {
          toast.error(response.data.data.message);
        }
      })
      .catch((error) => {
        /**
         * Alleen niet CANCEL errors afvangen
         */
        if (!error.__CANCEL__) {
          toast.error("Oeps er is iets mis gegaan!");
        }
      });
  }

  handleDupliceerAction = (row) => {
    this.setState({
      selectedIds: [row[0]],
      copyModal: true,
    });
  };

  handleTeamviewer = (row, rawRow) => {
    window.open("tvcontrol1://control?device=" + rawRow.remote_id, "_blank");
  };

  handleUseFilterAction = (row, rawRow) => {
    this.props.setFilter("vestiging_id", {
      field: "vestiging_id",
      operator: "=",
      value: row[0],
      label: row[3],
      appTarget: rawRow.appTarget,
    });
  };

  handleCustomDate = (row) => {
    return (
      <b>
        {this.getCleanDate(
          row?.last_order?.last_order_date
            ? parse(row?.last_order?.last_order_date, "yyyy-MM-dd HH:mm:ss", new Date())
            : null,
          "Last order",
          "n/a"
        )}{" "}
        <br />
        {this.getCleanDate(
          row?.volatile_salesarea_data?.lastSync ? new Date(row?.volatile_salesarea_data?.lastSync * 1000) : null,
          "Synced",
          "n/a"
        )}
      </b>
    );
  };

  handleCustomAPIPSP = (row) => {
    let runningRelease = "Custom Release";
    if (row.targetPlatform.search("https://jamezz.app") != -1) {
      runningRelease = "Stable";
    }
    if (row.targetPlatform.search("https://rc.jamezz.app") != -1) {
      runningRelease = "Release Candidate";
    }
    if (row.targetPlatform.search("https://staging.jamezz.app") != -1) {
      runningRelease = "Staging";
    }
    if (row.targetPlatform.search("https://alpha.jamezz.app") != -1) {
      runningRelease = "Alpha Testing";
    }
    if (row.targetPlatform.search("http://jamezzv2.test") != -1) {
      runningRelease = "Development";
    }
    if (row.targetPlatform.search("https://jamezzv2.test") != -1) {
      runningRelease = "Development (SSL)";
    }
    return (
      <>
        <b>{row.apiProvider} / </b>
        {row.payProvider ?? "n/a"}
      </>
    );
  };

  handleCloudStatus = (row) => {
    let cloudStatus = <></>;
    let ksStatus = <></>;
    let cloudVersion = <></>;
    if (row?.volatile_salesarea_data?.local_service_version) {
      cloudVersion = row?.volatile_salesarea_data?.local_service_version;
    }
    if (row?.volatile_salesarea_data?.cloudkeepalive) {
      const diff = differenceInMinutes(new Date(), new Date(row?.volatile_salesarea_data?.cloudkeepalive * 1000));
      cloudStatus =
        diff > 1 ? <ErrorOutline style={{ color: "#f44336" }} /> : <WbCloudy style={{ color: "#00a000" }} />;
    }
    if (row?.volatile_salesarea_data?.ksactive) {
      const diff = differenceInMinutes(new Date(), new Date(row?.volatile_salesarea_data?.ksactive * 1000));
      ksStatus =
        diff > 1 ? <SmartDisplay style={{ color: "#f44336" }} /> : <SmartDisplay style={{ color: "#00a000" }} />;
    }
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <div style={{ paddingTop: "5px" }}>{cloudStatus}</div>
        <div style={{ paddingTop: "5px" }}>{ksStatus}</div>
        <div>{cloudVersion}</div>
      </div>
    );
  };

  handleKSStatus = (row) => {
    if (row?.volatile_salesarea_data?.ksactive) {
      const diff = differenceInMinutes(new Date(), new Date(row?.volatile_salesarea_data?.ksactive * 1000));
      return (
        <div style={{ marginLeft: "20px" }}>
          {diff > 1 ? <SmartDisplay style={{ color: "#f44336" }} /> : <SmartDisplay style={{ color: "#00a000" }} />}
        </div>
      );
    }
    return <></>;
  };

  getCleanDate(date: Date | null, prefix = "", empty = "") {
    if (!date) return empty;

    const diffDays = differenceInDays(new Date(), date);
    const diffHours = differenceInHours(new Date(), date);
    const diffMin = differenceInMinutes(new Date(), date);
    const diffSec = differenceInSeconds(new Date(), date);
    let displayDiff = 0;
    let displayType = "days";
    if (diffDays >= 1) {
      /**
       * Days
       */
      displayDiff = diffDays;
    } else if (diffHours >= 1) {
      displayType = "hours";
      displayDiff = diffHours;
    } else if (diffMin >= 1) {
      displayType = "minutes";
      displayDiff = diffMin;
    } else if (diffSec >= 1) {
      displayType = "seconds";
      displayDiff = diffSec;
    }
    return diffDays > 5 ? (
      <span style={{ color: "#f44336" }}>
        <b>
          {prefix} {displayDiff} {displayType} ago
        </b>
      </span>
    ) : (
      <span style={{ color: "#00a000" }}>
        <b>
          {prefix} {displayDiff} {displayType} ago
        </b>
      </span>
    );
  }

  resetSyncState = (row) => {
    const data = {
      vid: [row[0]],
    };

    axios
      .post("/core/vestigingen/resetsyncstate", data)
      .then((response) => {
        if (response.data.data.success) {
          toast.success(response.data.data.message);
        } else {
          toast.error(response.data.data.message);
        }
      })
      .catch((error) => {
        /**
         * Alleen niet CANCEL errors afvangen
         */
        if (!error.__CANCEL__) {
          toast.error("Oeps er is iets mis gegaan!");
        }
      });
  };

  render() {
    const { classes } = this.props;
    const actions = [];

    actions.push({
      icon: Pageview,
      tooltip: getTranslation("Filter op", "Filter op"),
      action: this.handleUseFilterAction,
    });
    actions.push({
      permissionKey: "vestigingen.create",
      icon: Layers,
      tooltip: getTranslation("Duplicate", "Duplicate"),
      action: this.handleDupliceerAction,
    });
    actions.push({
      permissionKey: "vestigingen.teamviewer",
      icon: Computer,
      activeField: "remote_id",
      tooltip: getTranslation("Remote login", "Remote login"),
      action: this.handleTeamviewer,
    });

    return (
      <div>
        <MainNavbar paginaTitel={getTranslation("Verkoopgebieden overzicht", "Verkoopgebieden overzicht")} />
        <GridContainer>
          <GridItem xs={12}>
            <AuthenticationWrapper permissionKey={"vestigingen.create"}>
              <Button className={classes.marginRight} color={"success"} onClick={() => this.toggleModal("newModal")}>
                <Add className={classes.icons} /> {getTranslation("Nieuwe vestiging", "Nieuwe vestiging")}
              </Button>
            </AuthenticationWrapper>
          </GridItem>
        </GridContainer>
        <GridContainer sx={{ maxWidth: 1, overflowX: "auto" }}>
          <AuthenticationWrapper permissionKey={"vestigingen.testing_options"}>
            <GridItem xs={12}>
              <Button
                className={classes.marginRight}
                color={"warning"}
                onClick={() => {
                  if (confirm("Are you sure?")) {
                    this.migrateToStable();
                  }
                }}
              >
                <Add className={classes.icons} />{" "}
                {getTranslation(
                  "Migrate Release Candidate locations to Stable",
                  "Migrate Release Candidate locations to Stable"
                )}
              </Button>
            </GridItem>
            <GridItem xs={12}>
              <Button
                className={classes.marginRight}
                color={"danger"}
                onClick={() => {
                  if (confirm("Are you sure?")) {
                    this.migrateToRC();
                  }
                }}
              >
                <Add className={classes.icons} />{" "}
                {getTranslation(
                  "Migrate random customers (+10%) to Release Candidate platform",
                  "Migrate random customers (+10%) to Release Candidate platform"
                )}
              </Button>
            </GridItem>
          </AuthenticationWrapper>
        </GridContainer>

        <GridContainer>
          <GridItem md={4} xs={12}>
            <VenueFilter />
          </GridItem>
          <GridItem md={4} xs={12}>
            <TextFilter
              field={"systeemNaam"}
              fieldKey={"vestigingen:name"}
              operator={"like"}
              placeholder={getTranslation("vestigingen.filters.vestiging", "Filter op vestiging")}
            />
          </GridItem>
          <GridItem md={4} xs={12}>
            <TextFilter
              field={"id"}
              fieldKey={"vestigingen:id"}
              placeholder={getTranslation("vestigingen.filters.vestigingNr", "#")}
            />
          </GridItem>
          <AuthenticationWrapper permissionKey={"vestigingen.filter_on_pay_provider"}>
            <GridItem md={4} xs={12}>
              <PayProviderFilter />
            </GridItem>
          </AuthenticationWrapper>
          <AuthenticationWrapper permissionKey={"vestigingen.filter_on_api_provider"}>
            <GridItem md={4} xs={12}>
              <ApiProviderFilter />
            </GridItem>
          </AuthenticationWrapper>

          <GridItem md={4} xs={12}>
            <AppTargetFilter />
          </GridItem>
          <GridItem md={4} xs={12}>
            <SalesareaTypeFilter />
          </GridItem>
          <GridItem md={4} xs={12}>
            <CountryFilter />
          </GridItem>
          <GridItem md={4} xs={12}>
            <AuthenticationWrapper permissionKey={"vestigingen.testing_options"}>
              <TargetPlatformFilter />
            </AuthenticationWrapper>
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              actions={actions}
              dataMapping={[
                {
                  dbfield: "id",
                  editable: false,
                },
                {
                  dbfield: "systemOnline",
                  editable: true,
                  inputtype: "Switch",
                },
                { customData: this.handleCloudStatus },
                {
                  dbfield: "systeemNaam",
                  editable: false,
                },
                new JamezzTableLinkToRelation("venue.name", "/manager/venues/:id/edit", {
                  id: "venue_id",
                }),
                {
                  dbfield: "venue_id",
                  hide: true,
                },
                {
                  customData: this.handleCustomAPIPSP,
                },
                { customData: this.handleCustomDate },
              ]}
              dbfields={
                "id,systeemNaam,remote_id,appTarget,systemOnline,bediening,rekening,apiProvider,targetPlatform,payProvider,last_order.salesarea_id,last_order.last_order_date,volatile_salesarea_data.salesarea_id,volatile_salesarea_data.lastSync,volatile_salesarea_data.ksactive,volatile_salesarea_data.local_service_version,volatile_salesarea_data.cloudkeepalive,venue_id,venue.id,venue.name"
              }
              delete={"vestigingen.delete"}
              editLink={"./:id/edit"}
              editLinkPermission={"vestigingen/:id/edit"}
              fetchUrl={"core/vestigingen"}
              filters={this.props.filters}
              headerIcon={<Restaurant />}
              headers={[
                {
                  label: getTranslation("vestigingen.table.id", "#"),
                  sortable: true,
                  sortKey: "id",
                },
                {
                  label: getTranslation("vestigingen.table.actief", "Actief"),
                  sortable: false,
                },
                {
                  label: getTranslation("vestigingen.table.cloudstatus", "Services"),
                  sortable: false,
                },
                {
                  label: getTranslation("vestigingen.table.verkoopgebied", "Verkoopgebied"),
                  sortable: true,
                  sortKey: "systeemNaam",
                },
                {
                  label: getTranslation("vestigingen.table.venue", "Venue"),
                  sortable: true,
                  sortKey: "venue_id",
                },
                {
                  label:
                    getTranslation("vestigingen.table.api", "API") +
                    " / " +
                    getTranslation("vestigingen.table.payProvider", "PSP"),
                  sortable: false,
                },
                {
                  label:
                    getTranslation("vestigingen.table.laatsteBestelling", "Laatste bestelling") +
                    "<br />" +
                    getTranslation("vestigingen.table.lastImport", "Laatste import") +
                    "<br />",
                  sortable: true,
                  sortKey: "last_order_id",
                },
              ]}
              reduxKey={"vestiging"}
              ref={this.jamezzTable}
              showAutoRenew
              showRefresh
              tableTitle={getTranslation("Verkoopgebieden", "Verkoopgebieden")}
            />
          </GridItem>
        </GridContainer>

        {/*MODALS*/}
        <Copy
          open={this.state.copyModal}
          refreshTable={() => this.refreshJamezzTable()}
          toggle={() => this.toggleModal("copyModal")}
          vestigingIds={this.state.selectedIds}
        />

        <New open={this.state.newModal} toggle={() => this.toggleModal("newModal")} />
      </div>
    );
  }
}

Index.propTypes = {
  classes: PropTypes.object,
};

Index.contextType = DialogContext;

//REDUX
const mapStateToProps = (state) => {
  const filters = {};
  if (state.filtersV2["vestigingen:name"]) {
    filters["vestigingen:name"] = state.filtersV2["vestigingen:name"];
  }
  if (state.filtersV2["payProvider"]) {
    filters["payProvider"] = state.filtersV2["payProvider"];
  }
  if (state.filtersV2["apiProvider"]) {
    filters["apiProvider"] = state.filtersV2["apiProvider"];
  }
  if (state.filtersV2["appTarget"]) {
    filters["appTarget"] = state.filtersV2["appTarget"];
  }
  if (state.filtersV2["targetPlatform"]) {
    filters["targetPlatform"] = state.filtersV2["targetPlatform"];
  }
  if (state.filtersV2["salesarea_type"]) {
    filters["salesarea_type"] = state.filtersV2["salesarea_type"];
  }
  if (state.filtersV2["country"]) {
    filters["country"] = state.filtersV2["country"];
  }
  if (state.filtersV2["vestigingen:id"]) {
    filters["vestigingen:id"] = state.filtersV2["vestigingen:id"];
  }
  if (state.filtersV2["vestiging.venue_id"]) {
    filters["vestiging.venue_id"] = { ...state.filtersV2["vestiging.venue_id"] };
    filters["vestiging.venue_id"].field = "venue_id";
  }
  return { filters };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setFilter: (key, filter) => {
      dispatch({
        type: actions.SET_FILTER,
        payload: { key, filter },
      });
    },
    showMessage: (message) =>
      dispatch({
        type: actions.SHOW_MESSAGE,
        message: message,
      }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(Index, vestigingStyle));
